import React, { ReactNode, createContext, useContext, useState } from 'react';
import { VerticalSystemTabItem, VerticalSystemVariant } from '../types';

type VerticalSystemContextModel = {
  activeTabItem?: VerticalSystemTabItem;
  activeVariant?: VerticalSystemVariant;
  tabItems: VerticalSystemTabItem[];
};

type VerticalSystemContextAction = {
  setActiveTabItem: (activeTabItem?: VerticalSystemTabItem) => void;
  setActiveVariant: (activeVariant?: VerticalSystemVariant) => void;
};

export const initialVerticalSystemContextModel: VerticalSystemContextModel = {
  tabItems: [],
};

const initialVerticalSystemContext: VerticalSystemContextModel & VerticalSystemContextAction = {
  ...initialVerticalSystemContextModel,
  setActiveTabItem: () => {},
  setActiveVariant: () => {},
};

const VerticalSystemContext = createContext(initialVerticalSystemContext);

export const useVerticalSystemContext = () => useContext(VerticalSystemContext);

type VerticalSystemContextProviderProps = {
  children: ReactNode;
  initialContext?: Partial<VerticalSystemContextModel>;
};

export const VerticalSystemContextProvider = ({
  initialContext,
  children,
}: VerticalSystemContextProviderProps) => {
  const [contextModel, setContextModel] = useState({
    ...initialVerticalSystemContextModel,
    ...initialContext,
    activeTabItem: initialContext?.activeTabItem ?? initialContext?.tabItems?.at(0),
  });
  return (
    <VerticalSystemContext.Provider
      value={{
        ...contextModel,
        setActiveTabItem: (activeTabItem?: VerticalSystemTabItem) => {
          setContextModel(prev => ({ ...prev, activeTabItem }));
        },
        setActiveVariant: (activeVariant?: VerticalSystemVariant) => {
          setContextModel(prev => ({ ...prev, activeVariant }));
        },
      }}
    >
      {children}
    </VerticalSystemContext.Provider>
  );
};
